import styled from "styled-components";

export const RegisterWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    max-width: 102.3rem;
    width: 100%;
    display: flex;
    padding: 0 2rem;
    gap: 12.6rem;

    & > :nth-child(1) {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-width: 37.7rem;
    }

    & > :nth-child(2) {
      max-width: 50rem;
      width: 100%;
      border: 0.2rem solid var(--color-grey-0);
      padding: 2rem 2.6rem;
      border-radius: 0.5rem;
      gap: 1.9rem;
      & > div {
        display: flex;
        justify-content: space-between;
        align-self: center;
        & > a {
          align-self: center;
          font-weight: 500;
          font-size: 1.4rem;
          line-height: 2.2rem;
          height: 3.6rem;
          color: var(--color-grey-50);
        }
      }
    }
  }

  @media (max-width: 768px) {
    & > div {
      margin-top: 5.3rem;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1.4rem;
      max-width: 37.7rem;
      width: 100%;
      padding: 0 2rem;

      & > :nth-child(2) {
        max-width: 32.1rem;
        width: 100%;
      }
    }
  }
`;
